import SmsLogList from './list.vue'
let a = Object.assign({SmsLogList}, {})
export default a;
